<div id="about--container">
  <div id="title--container">
    <h4>About</h4>
    <h5>{{ laboratory()?.laboratoryName }}</h5>
  </div>
  <hr />
  <div id="content--container">
    <div class="release-notes--header">
      <h6>Release Notes</h6>
      <div class="button--container">
        <app-icon-button
          label="Clear Filters"
          buttonStyle="transparent--dark-blue"
          buttonId="clear-filter-btn"
          buttonShape="square"
          (buttonClicked)="resetFilters()"
          title="Clear Filters"
          [isDisabled]="!selectedCategoriesList().length"
        ></app-icon-button>
        <app-icon-button
          label="filters"
          buttonStyle="secondary"
          buttonId="filter-btn"
          iconName="filter_list"
          buttonShape="square"
          (buttonClicked)="openModal('filter')"
          title="Filters"
        ></app-icon-button>
      </div>
    </div>
    @for (releaseNote of filteredReleaseNotes(); track releaseNote.datePublished.getTime()) {
      <app-release-note [releaseNote]="releaseNote"></app-release-note>
    }
    @if (filteredReleaseNotes().length === 0) {
      <div id="no-results">
        <h5>No results found</h5>
      </div>
    }
  </div>
</div>
<div id="footer">
  <div class="links">
    <a href="https://ogibiotec.com/privacy-policy/" target="_blank" rel="noopener noreferrer"
      >Privacy Policy</a
    >
    |
    <a href="https://ogibiotec.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer"
      >Terms & Conditions</a
    >
    |
    <a href="https://ogibiotec.com/end-user-license/" target="_blank" rel="noopener noreferrer">EULA</a>
  </div>
</div>
<app-filter-modal
  id="filter"
  primaryButtonText="Apply Filters"
  primaryButtonId="continue-button"
  secondaryButtonText="Reset"
  secondaryButtonId="reset-button"
  [modulesField]="categoryFilters"
  [parentForm]="filterControls"
  [hideDeletedField]="true"
  [isProcessing]="isProcessing()"
  (modalButtonClicked)="filterModalButtonClicked($event)"
  (moduleCheckboxClicked)="moduleCheckboxClicked($event)"
></app-filter-modal>
